import { graphql } from '~publish/graphql'
import type { FragmentOf } from '~publish/graphql'

/**
 * What one message needs to render as a bubble in the thread.
 *
 * `quote` and `send.failureCode` are left out on purpose: quoted replies and
 * delivery state are not shown yet. `send.sentAt` is selected because a
 * message we sent that the network has not published carries no
 * `publishedAt`, and the thread still has to place it.
 */
export const ThreadMessage_ConversationMessage = graphql(/* GraphQL */ `
  fragment ThreadMessage_ConversationMessage on ConversationMessage @_unmask {
    __typename
    id
    conversationId
    isOwnMessage
    contentType
    text
    publishedAt
    isEdited
    isServiceDeleted
    author {
      name
      username
      avatar
      letterAvatar {
        letter
        textColor
        backgroundColor
      }
    }
    assets {
      assetId
      type
      url
      width
      height
    }
    reactions {
      emoji
    }
    send {
      state
      sentAt
    }
  }
`)

export type ThreadMessageData = FragmentOf<
  typeof ThreadMessage_ConversationMessage
>
